import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HeadPageComponent from '../../components/layout/headpage/headpage';

import './post.scss';
import {
  faAdd,
  faImages,
  faRedo,
  faNewspaper,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonUI from '../../components/ui/button/button';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ContentFormatButton from '../../components/ui/toggle-format/toggle-format';
import PostTab from './post-tab/post-tab';
import { getMenuList, getPosts } from '../../services/post.service';
import { appActions } from '../../store/app-slice';

const PostPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['post-page']);
  const language = useSelector((state) => state.app.language);
  const uPermission = useSelector((state) => state.auth.userPermission);
  const [pageAvailable, setPageAvailable] = useState([]);
  const [postTab, setPostTab] = useState('0');
  const [isRowDisplay, setIsRowDisplay] = useState(false);
  const [postData, setPostData] = useState([]);
  const [pageControl, setPageControl] = useState('');
  const [menuList, setMenuList] = useState([]);
  const [category, setCategory] = useState([]);
  const [refreshData, setRefreshData] = useState(0);
  const [spawnActive, setSpawnActive] = useState(true);
  const [postModalAdd, setPostModalAdd] = useState(false);
  const [textSearch, setTextSearch] = useState('');
  const rulesAddPost = uPermission.superAdmin && language === 'th';

  useEffect(() => {
    setPostData([]);
    dispatch(appActions.isSpawnActive(true));
    getPosts(language)
      .then((res) => {
        // console.log(res);
        const idsToExclude = [7, 8]; // Add more IDs to this array to exclude them, e.g., [2, 3, 5]
        let filteredMenuList = res.menuPage.filter(
          (category) => !idsToExclude.includes(category.id)
        );

        if (res.status) {
          setPostData(res.data);
          setPageAvailable(res.menuPage);
          setMenuList(filteredMenuList);
          let arr = [];
          for (let obj of res.menuPage) {
            arr[`${obj.id}`] = {
              id: obj.id,
              title: obj.title,
              language: obj.language,
              level: obj.cateLevel,
              rootId: obj.rootId,
              parentId: obj.parentId,
              checked: false,
            };
          }
          // console.log(arr);
          setCategory(arr);
        }
        dispatch(appActions.isSpawnActive(false));
        setSpawnActive(false);
      })
      .catch(() => {
        dispatch(appActions.isSpawnActive(false));
        setSpawnActive(false);
      });
  }, [refreshData, language, dispatch, spawnActive]);

  const OnChangePageControlHandler = (e) => {
    setPageControl(e.target.value);
  };

  const refreshHandle = () => {
    setSpawnActive(true);
    setRefreshData((prev) => prev + 1);
  };
  // console.log(menuList, category);
  return (
    <section id="post-page">
      <HeadPageComponent
        h1={t('PostH1')}
        icon={<FontAwesomeIcon icon={faNewspaper} />}
        breadcrums={[{ title: t('PostH1'), link: false }]}
      />
      <div className="card-control fixed-width">
        <div className="card-head">
          <div className="head-action">
            <h2 className="head-title">
              <ButtonUI
                onClick={refreshHandle}
                on="create"
                isLoading={false}
                icon={<FontAwesomeIcon icon={faRedo} />}
              >
                {t('Fetch')}
              </ButtonUI>
            </h2>
            <ContentFormatButton
              isRowDisplay={isRowDisplay}
              setIsRowDisplay={setIsRowDisplay}
            />
            <FormControl className="searchpage" variant="standard">
              <InputLabel id="filter-pgae">{t('SelectPageControl')}</InputLabel>
              <Select
                labelId="post-pgae"
                autoWidth
                id="filter-page"
                label={t('SelectPageControl')}
                className="input-page"
                size="small"
                onChange={OnChangePageControlHandler}
                value={pageControl}
              >
                <MenuItem value="">{t('SelectPageControlNone')}</MenuItem>
                {pageAvailable &&
                  pageAvailable.map((menu) => (
                    <MenuItem key={menu.id} value={menu.id}>
                      {menu.title}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <div className="action-right">
              <TextField
                value={textSearch}
                label={t('Search')} //ค้นหา
                id="outlined-size-small"
                size="small"
                onChange={(e) => setTextSearch(e.target.value)}
              />
              {rulesAddPost && (
                <ButtonUI
                  onClick={() => setPostModalAdd(true)}
                  className="btn-add-post"
                  on="create"
                  icon={<FontAwesomeIcon icon={faAdd} />}
                >
                  {t('PostAdd')}
                </ButtonUI>
              ) }
            </div>
          </div>
        </div>

        <PostTab
          postModalAdd={postModalAdd}
          setPostModalAdd={setPostModalAdd}
          setRefreshData={() => setRefreshData(refreshData + 1)}
          pageControl={pageControl}
          category={category}
          setCategory={setCategory}
          menuList={menuList}
          postTab={postTab}
          setPostTab={setPostTab}
          postData={postData}
          isRowDisplay={isRowDisplay}
          textSearch={textSearch}
        />
      </div>
    </section>
  );
};

export default PostPage;
